import { combineReducers } from 'redux';
import { routerReducer } from '../../common/router';
import { communitiesContext } from '../../common/store/communities-context/communities-context-reducer';
import forumData from './forum-data';
import isLoaded from './is-loaded';
import isLoading from './is-loading';
import { membersGroups } from './members-groups';
import { location } from '../../common/store/location/location-reducer';
import { maNavigation } from '../../common/store/ma-navigation/ma-navigation-reducer';
import pagination from './pagination';
import posts from './posts';
import search from './search';
import categories from './categories';
import { sorting } from './sorting';
import { filtering } from './filtering';
import { translations } from '../../common/store/translations/translations-reducer';
import { basicParams } from '../../common/store/basic-params/basic-params-reducer';
import { experiments } from './experiments';
import { modalReducer } from '../../common/modals/framework/initialize-store';
import { messageReducer } from '../../common/messages/framework/initialize-store';
import { currentUser } from '../../common/store/current-user/current-user-reducer';
import { promisifiedActionsResults } from '../../common/actions-promisifier/store/promisified-actions-reducer';
import { debugState } from '../../common/store/debug-state/debug-state-reducer';
import { instanceValues } from '../../common/store/instance-values/instance-values-reducer';
import { fastFormSubmit } from '../../common/components/fast-form/store/fast-form-reducer';
import { appLoaded } from '../../common/store/app-loaded/app-loaded-reducer';
import { footerPosts } from './footer-posts';
import { relatedPosts } from './related-posts';
import { badges } from './badges';
import { paidPlans } from './paid-plans';
import { styleParams } from '../../common/store/style-params/style-params-reducer';
import { savedAction } from '../../common/store/saved-action/saved-action-reducer';
import { offlineMigration } from './offline-migration';
import { reloadPage } from './reload-page';
import { siteId } from './site-id';
import { externalLinks } from './external-links';
import { similarPosts } from './similar-posts';
import { localStorage } from './local-storage';
import { combineReducersR } from '@wix/communities-forum-client-commons';
import { counters } from './counters';
import { customRoutes } from '../../common/store/custom-routes/custom-routes-reducer';
import { verticalEmbed } from './vertical-embed';
import { headerNavigation } from '../containers/header-navigation';
import { userActivity } from '../containers/user-activity';
import { membersReducer } from '../../common/store/members/members-reducer';

export default combineReducersR(combineReducers)({
  appLoaded,
  fastFormSubmit,
  debugState,
  promisifiedActionsResults,
  experiments,
  translations,
  basicParams,
  ...modalReducer({ allowUpdateToModals: [] }),
  ...routerReducer,
  ...messageReducer,
  communitiesContext,
  customRoutes,
  forumData,
  instanceValues,
  isLoaded,
  isLoading,
  membersGroups,
  location,
  maNavigation,
  pagination,
  posts,
  search,
  categories,
  currentUser,
  sorting,
  footerPosts,
  relatedPosts,
  badges,
  paidPlans,
  styleParams,
  savedAction,
  filtering,
  offlineMigration,
  reloadPage,
  siteId,
  similarPosts,
  externalLinks,
  localStorage,
  counters,
  verticalEmbed,
  headerNavigation,
  userActivity,
  members: membersReducer,
});
